import { useCallback, useMemo } from 'react';
import { useStatePiece } from 'react-pieceful-state';

const useSharedState = <T>(base: string, initial: T, region = 'editAsset') => {
  const [value, setValue, resetValue] = useStatePiece<T>(base, initial, region);

  const setVal = useCallback((v: T) => setValue(() => v), []);
  const resetVal = useCallback((v: T) => resetValue(() => v), []);

  return useMemo(() => [value, setVal, resetVal] as const, [value, setVal, resetVal]);
};

export default useSharedState;
